
import React, { useState, useEffect } from 'react';
import styles from '../App.module.scss';
import { useTranslation } from 'react-i18next';



function isMobileDevice(screenWidthVal = 768) {
  const userAgent = navigator.userAgent;
  const screenWidth =
    window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
  const isMobile = /Mobile/i.test(userAgent) || screenWidth < screenWidthVal;
  return isMobile;
}
const About = () => {
    const { t, i18n } = useTranslation();

    useEffect(() => {
        
      
    }, []);
    return (
      <div className={styles.about_wrapper}>
        <div className={styles.title}>{t("about.about_us")}</div>
        <div className={styles.line}></div>

        <div className={styles.content}>
            <div className={styles.subTitle}>{ isMobileDevice() ? t("about.our_vision") : <img src={t("about.our_vision_pic")} className={styles.pic_title} alt="" />
}</div>
            <div className={styles.vision}>{t("about.our_vision_desc")}</div>
            <div className={styles.subTitle}>{ isMobileDevice() ? t("about.our_mission") : <img src={t("about.our_mission_pic")} className={styles.pic_title} alt="" />
}</div>
            <ol className={styles.text} dangerouslySetInnerHTML={{ __html: t('about.our_mission_desc') }}></ol>
            <img className={styles.pic2} src={require(`../images/about/pic-2.png`)} alt="" />
            <img className={styles.zhuangshi} src={require(`../images/about/zhuangshi.png`)} alt="" />
        </div>
      </div>
    );
  };

export default About;